<template>
	<section :class="{ 'dark-bg': theme === 'dark' }">
		<div class="container">
			<h2 class="alfa text-center mb-5" :class="{ 'text-white': theme === 'dark' }">
				Your Questions <br />
				<strong>Answered</strong>
			</h2>

			<div class="row justify-content-center">
				<div class="col-60" :class="{ 'col-lg-45': !fullWidth }">
					<BaseAccordion :data="faqData" :theme="theme" />
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: "FaqSection",
	data() {
		return {};
	},
	props: {
		fullWidth: {
			type: Boolean,
		},
		theme: {
			type: String,
		},

		faqData: {
			type: Array,
		},
	},
};
</script>
